import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, throwError, timer, firstValueFrom, of } from 'rxjs';
import { appConfig, baseUrl, intUrl, localUrl } from '../app.config';
import { map, catchError,mergeMap,  retryWhen, switchMap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatomoTracker } from 'ngx-matomo';
import { AuthorizationService } from '../authorization.service';
import { ConfigService } from './config.service';
import { ViewSupplierServiceService } from '../view-supplier-service.service';

const HTTP_STATUS_INTERNAL_SERVER_ERROR = 500;
const HTTP_STATUS_NOT_IMPLEMENTED = 501;
const HTTP_STATUS_BAD_GATEWAY = 502;
const HTTP_STATUS_SERVICE_UNAVAILABLE = 503;
const HTTP_STATUS_GATEWAY_TIMEOUT = 504;
const HTTP_STATUS_UNAUTHORIZED = 401;
const HTTP_STATUS_NETWORK_FAILURE = 0;
const MAX_RETRY_COUNT = 3;
const ONE_MINUTE_MS = 60000;
const SECONDS_PER_MINUTE = 60;

@Injectable()
export class CommonService {
  fromApp_UserIPN = "";
  fromApp_UserRole = "";
  fromApp_UserEmail = "";
  fromApp_UserName = "";
  PortfolioRecordSet = "";
  supplierRole = false;
  module: any;
  config: any;
  ENV: any;
  public userInfo: any
  public href = "";
  currentRole = '';
  Notautorized = "You are not authorized. Please contact admin team (isa@renault.com).";
  public administrationReset$ = new Subject<string>();
  allActiveTask: any[] = [];
  errorMessage = false;
  mailSub: any;
  noIpnSupplier = false;
  pageString = '&_pagesize='
  constructor(private http: HttpClient, public configservice:ConfigService,public viewSupplierApi:ViewSupplierServiceService,public _router:Router,public authorizationService: AuthorizationService ,private router: Router, private matomoTracker: MatomoTracker) {

    this.config = appConfig;
    this.ENV = environment;
    this.environmentCheck()

    this.allActiveTask = [];
  }

  getCurrentUrl() {
    return this.router.url;
  }
  reDirectURL() {
    let ss = window.location.href.split('/', 6);
    if (ss[4] != undefined) {
      ss[4] = `/${ss[4]}`;
    } else {
      ss[4] = '';
    }
    if (ss[5] != undefined) {
      ss[5] = `/${ss[5]}`;
    } else {
      ss[5] = '';
    }
    sessionStorage.setItem('redirectCheck', `/${ss[3]}${ss[4]}${ss[5]}`);
  }

  environmentCheck() {
    if(baseUrl.includes('localhost')){
      this.mailSub = 'ISA-LocalHost: '
    } else if(baseUrl.includes('dev')){
      this.mailSub = 'ISA-DEV: '
    } else if(baseUrl.includes('ppd')){
      this.mailSub = 'ISA-PPD:'
    } else if(baseUrl.includes('int')){
      this.mailSub = 'ISA-INT: '
    } else {
      this.mailSub = 'ISA: '
    }
  }

  checktls(url: any) {
    let is_Tls = false;
    if (url.includes(this.config.ApiPurchasingUrl)) {
      is_Tls = true;
    } else if (url.includes(this.config.ApiContactsUrl)) {
      is_Tls = true;
    } else if (url.includes(this.config.ApiArcaURL)) {
      is_Tls = true;
    }
    let baseUrl1 =
      baseUrl
    return false;
  }

 public handleApiError<T>(apiCall: Observable<T>,url = { qry: '' },method=''): Observable<T> {
  return apiCall.pipe(


    retryWhen(error$ =>
      error$.pipe(
        mergeMap((err, retryCount) => {
          console.info("RetryWhen caught:", err);
          console.info("RetryWhen caught status:", err?.status);

          let retriableErrors = [HTTP_STATUS_INTERNAL_SERVER_ERROR, HTTP_STATUS_NOT_IMPLEMENTED, HTTP_STATUS_BAD_GATEWAY, HTTP_STATUS_SERVICE_UNAVAILABLE, HTTP_STATUS_GATEWAY_TIMEOUT];
          const statusCode = err?.status !== undefined ? err.status : err;
          const isNetworkFailureText = typeof err === 'string' && /error code:\s*0\b/i.test(err);
          const errorCodeMatch = typeof err === 'string' ? err.match(/error code:\s*(\d+)/i) : null;
          const isRetriableCodeText = errorCodeMatch !== null && retriableErrors.includes(+errorCodeMatch[1]);
          if ((retriableErrors.includes(statusCode) || isNetworkFailureText || isRetriableCodeText) && retryCount < MAX_RETRY_COUNT) {
            console.info("Retrying API... attempt:", retryCount + 1);
            console.info('Retrying in 60s...');  
            return timer(ONE_MINUTE_MS);
          }

          return throwError(err);
        })
      )
    ),


    catchError(err => {
      console.info("Final catchError:", err);

      let friendlyMessage = 'Something went wrong; please try again later.';
      if (err.status === HTTP_STATUS_INTERNAL_SERVER_ERROR) {
        friendlyMessage = 'Internal Server Error. Retry attempts failed.';
      }
       if (err.status === 0) {
        friendlyMessage = 'Network error. Check your connection.';
        }
      if (window.location.href.includes('administration')) {
        const path = url.qry.replace(/^https?:\/\/[^.]+\./, '').replace(/\?.*$/, '');     
        const errorCodes = [HTTP_STATUS_INTERNAL_SERVER_ERROR, HTTP_STATUS_BAD_GATEWAY, HTTP_STATUS_SERVICE_UNAVAILABLE, HTTP_STATUS_GATEWAY_TIMEOUT, HTTP_STATUS_NOT_IMPLEMENTED];
        if (errorCodes.some(word => err.includes(word))) {
          const detectedCode = errorCodes.find(code => err.includes(code.toString())) ?? null;
          let message = ` Error ${detectedCode} on ${method}: ${path}`;
          this.administrationReset$.next(message);
        }
      }
      console.info('Error Message', friendlyMessage);

      return throwError(() => err);
    })
  );
}





  getServiceCall(url: any,query) : Observable<any> {

    let idpToken = localStorage.getItem('IDPAccessToken') || '';
if(this.getCurrentUrl().toLowerCase().indexOf('view-supplier')!=-1){
  if(this.userInfo==null || (idpToken=='' || idpToken==null || idpToken==undefined)){
    idpToken= this.viewSupplierApi.createToken();
  }
}
   if( query.indexOf(this.config.ApiK2SocleUrl)!=-1|| query.indexOf(this.config.ApiK2Url)!=-1)
   {
    idpToken = localStorage.getItem('IDPAccessToken');
   }
    let headers = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
      })
    }
    
    let data = {
      "qry": query
    }
    return this.handleApiError(this.http.post(url, data,headers),data,'GET' )as Observable<any>;

  }
  getSupplierServiceCall(url: any,query) : Observable<any> {
    let token= this.viewSupplierApi.createToken();
console.info('getCurrentUrl',this.getCurrentUrl())
    let idpToken = localStorage.getItem('IDPAccessToken');

   if( query.indexOf(this.config.ApiK2SocleUrl)!=-1|| query.indexOf(this.config.ApiK2Url)!=-1)
   {
    idpToken = localStorage.getItem('IDPAccessToken');
   }
    let headers = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
      })
    }
    
    let data = {
      "qry": query
    }
    return this.handleApiError(this.http.post(url, data,headers),data,'GET' )as Observable<any>;

  }
  postServiceCall(apiUrl,url: any, data: any): Observable<any> {
    let idpToken = localStorage.getItem('IDPAccessToken');
    if(this.getCurrentUrl().toLowerCase().indexOf('view-supplier')!=-1){
      if(this.userInfo==null || (idpToken=='' || idpToken==null || idpToken==undefined)){
        idpToken= this.viewSupplierApi.createToken();
      }
    }
    if( url.indexOf(this.config.ApiK2SocleUrl)!=-1|| url.indexOf(this.config.ApiK2Url)!=-1)
    {
     idpToken = localStorage.getItem('IDPAccessToken');
    }
    let headers = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
      })
    }
        let datas = {
          "qry": url,
          "param": data
        }
        return this.handleApiError(this.http.post(apiUrl,datas, headers),datas,'POST')as Observable<any>  ;
      
  }
  UpdateServiceCall(apiUrl,url: any, data: any): Observable<any>{
    let idpToken = localStorage.getItem('IDPAccessToken');
    if(this.getCurrentUrl().toLowerCase().indexOf('view-supplier')!=-1){
      if(this.userInfo==null || (idpToken=='' || idpToken==null || idpToken==undefined)){
        idpToken= this.viewSupplierApi.createToken();
      }
    }
    if( url.indexOf(this.config.ApiK2SocleUrl)!=-1|| url.indexOf(this.config.ApiK2Url)!=-1)
    {
     idpToken = localStorage.getItem('IDPAccessToken');
    }
        let headers = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
      })
    }
    let datas = {
      "qry": url,
      "param": data
    }
    return this.handleApiError( this.http.post(apiUrl, datas,headers),datas,'UPDATE') as Observable<any>
  
}
  deleteServiceCall(apiUrl,url: any) : Observable<any>{
    let idpToken = localStorage.getItem('IDPAccessToken');
    if(this.getCurrentUrl().toLowerCase().indexOf('view-supplier')!=-1){
      if(this.userInfo==null || (idpToken=='' || idpToken==null || idpToken==undefined)){
        idpToken= this.viewSupplierApi.createToken();
      }
    }
    if( url.indexOf(this.config.ApiK2SocleUrl)!=-1|| url.indexOf(this.config.ApiK2Url)!=-1 )
    {
     idpToken = localStorage.getItem('IDPAccessToken');
    }
    let headers = {
      headers: new HttpHeaders({
        Authorization: `Bearer ${idpToken}`,
      })
    }
    let datas = {
      "qry": url
    }
    return this.handleApiError( this.http.post(apiUrl, datas,headers),datas,'DELETE') as Observable<any>
  }


  response(data,type,key):Observable<typeof type>{
    return data.pipe(
      map((response:typeof type) => {  
        return response ? response : { [key]: [] }
      }) 
    ) as Observable<typeof type>
  }

  get(url: any) {
      let twentyMinutesLater = new Date();
      let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
      let accessToken = '';
      let httpOptions;
      if (localStorage.getItem('accessToken') && parseInt(localStorage.getItem('expiredtime')) >= curentmni && parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
      accessToken = localStorage.getItem('accessToken');
      if(this.config.apikey === undefined || this.config.apikey === "" ){
      let dataPromise = firstValueFrom(this.getHappi());
      let apikey=''
      dataPromise.then((data) => {

        apikey=data['HAPPI_API_KEY']
      }).catch((error) => {
        console.info('Error in getHappi()',error);

      });
        httpOptions = {
          headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${accessToken}`,
          'apikey': apikey
          })
          };
          return this.http.get(url, httpOptions);
      }else{
      httpOptions = {
      headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
      'apikey': this.config.apikey,
      })
      };
      return this.http.get(url, httpOptions);
    }
      } else {
        let twentyMinutesLater22 = new Date();
        let curentmni22 = twentyMinutesLater22.setMinutes(twentyMinutesLater22.getMinutes());
       
        if(localStorage.getItem('accessToken')==undefined ||  (parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni22 && parseInt(localStorage.getItem('expiredtime')) < curentmni22)){

          let token = localStorage.getItem("IDPAccessToken");
          let httpOptions = {
            headers: new HttpHeaders({
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }),
          };
          this.http.get(`${baseUrl}/api/access_token`, httpOptions).subscribe((Acc_token: any) => {
            console.info("token --->3", Acc_token);
            let frmTime = Math.round((Acc_token.expires_in) / SECONDS_PER_MINUTE);// in mins
            let thirtymin = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + frmTime);
            localStorage.setItem('accessToken', Acc_token.access_token);
            localStorage.setItem("expiredtime", JSON.stringify(thirtymin));
            localStorage.setItem("expiresMin", `TIME ${frmTime}`);
            httpOptions = {
              headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`,
              'apikey': this.config.apikey,
              })
              };
              return this.http.get(url, httpOptions);
          }, _error => {
            window.location.reload();
          })  
        } else{
          this.refreshToken();
        }
     }
    
  }
async getCommonToken(){
  let base_Url=baseUrl
  if (baseUrl === localUrl || baseUrl === `${localUrl}/`) {
    base_Url = intUrl;

  }
return await firstValueFrom(this.http.get(`${base_Url}/api/access_token`));

}

CommonToken(){
  let base_Url=baseUrl;
  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
    })
  };
  if (baseUrl === localUrl || baseUrl === `${localUrl}/`) {
    base_Url = intUrl;

  }
  return this.http.get(`${base_Url}/api/access_token`,httpOptions);
  
  }
  getService(id: any) {
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(
      twentyMinutesLater.getMinutes()
    );
    let accessToken = "";
    let httpOptions;
    if (
      localStorage.getItem("accessToken") &&
      parseInt(localStorage.getItem("expiredtime")) >= curentmni &&
      parseInt(localStorage.getItem("IDPexpiredtime")) >= curentmni
    ) {
      accessToken = localStorage.getItem("accessToken");
      httpOptions = {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
          apikey: this.config.apikey,
        }),
      };
      return this.http
        .get(`${this.config.ApiPurchasingUrl}` + id, httpOptions)
        .pipe(map((response) => response))
        .pipe(
          catchError((error: any) => {
            if (error.status === HTTP_STATUS_UNAUTHORIZED) {
              return throwError(() => new Error(error.status));
            } else {
              return throwError(() => new Error(error.status));
            }
          })
        );
    } else {
      this.refreshToken();
    }
  }

  // post(url: any, data: any) {
  //   if (this.checktls(url)) {
  //     url = url.replace('renault.com/', 'tls.renault.com/');
  //     let baseUrl1 = baseUrl
  //     let query = url.split("?");
  //     if (baseUrl1 === localUrl || baseUrl1 === localUrl + "/") {
  //       baseUrl1 = intUrl;

  //     }
  //     let datas = {
  //       "qry": url,
  //       "param": data
  //     }
  //     return this.http.post(baseUrl1 + "/api/postSuppContact", datas);
  //   }
  //   else {
  //     let twentyMinutesLater = new Date();
  //     let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
  //     let accessToken = '';
  //     let httpOptions;
  //     if (localStorage.getItem('accessToken') && parseInt(localStorage.getItem('expiredtime')) >= curentmni && parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
  //       accessToken = localStorage.getItem('accessToken');
  //       httpOptions = {
  //         headers: new HttpHeaders({
  //           'Content-Type': 'application/json',
  //           'Authorization': 'Bearer ' + accessToken,
  //           'apikey': this.config.apikey,
  //         })
  //       };
  //       return this.http.post(url, data, httpOptions);
  //     } else {
  //       this.refreshToken();
  //     }
  //   }
  // }

  // delete(url: any) {
  //   if (this.checktls(url)) {
  //     url = url.replace('renault.com/', 'tls.renault.com/');
  //     let baseUrl1 = baseUrl
  //     let query = url.split("?");
  //     if (baseUrl1 === localUrl || baseUrl1 === localUrl + "/") {
  //       baseUrl1 = intUrl;

  //     }
  //     let datas = {
  //       "qry": url

  //     }
  //     return this.http.post(baseUrl1 + "/api/deleteSuppContact", datas);
  //   }
  //   else {
  //     let twentyMinutesLater = new Date();
  //     let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
  //     let accessToken = '';
  //     let httpOptions;
  //     if (localStorage.getItem('accessToken') && parseInt(localStorage.getItem('expiredtime')) >= curentmni && parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
  //       accessToken = localStorage.getItem('accessToken');
  //       httpOptions = {
  //         headers: new HttpHeaders({
  //           'Content-Type': 'application/json',
  //           'Authorization': 'Bearer ' + accessToken,
  //           'apikey': this.config.apikey,
  //         })
  //       };
  //       return this.http.delete(url, httpOptions,);
  //     } else {
  //       this.refreshToken();
  //     }
  //   }
  // }

  updateSub(url: any, data: any) {
    if (this.checktls(url)) {
      url = url.replace('renault.com/', 'tls.renault.com/');
      let baseUrl1 = baseUrl
      let query = url.split("?");
      if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {
        baseUrl1 = intUrl;

      }
      let datas = {
        "qry": url,
        "param": data

      }
      return this.http.post(`${baseUrl1}/api/putSuppContact`, datas);
    }
    else {
      let twentyMinutesLater = new Date();
      let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
      let accessToken = '';
      let httpOptions;
      if (localStorage.getItem('accessToken') && parseInt(localStorage.getItem('expiredtime')) >= curentmni && parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
        accessToken = localStorage.getItem('accessToken');
        httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${accessToken}`,
            'apikey': this.config.apikey,
          })
        };
        return this.http.put(url, data, httpOptions);
      } else {
        this.refreshToken();
      }
    }
  }

  // updatePur(url: any, data: any) {
  //   if (this.checktls(url)) {
  //     url = url.replace('renault.com/', 'tls.renault.com/');
  //     let baseUrl1 = baseUrl
  //     let query = url.split("?");
  //     if (baseUrl1 === localUrl || baseUrl1 === localUrl + "/") {
  //       baseUrl1 = intUrl;
  //     }
  //     let datas = {
  //       "qry": url,
  //       "param": data
  //     }
  //     return this.http.post(baseUrl1 + "/api/putSuppContact", datas);
  //   }
  //   else {
  //     let twentyMinutesLater = new Date();
  //     let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
  //     let accessToken = '';
  //     let httpOptions;
  //     if (localStorage.getItem('accessToken') && parseInt(localStorage.getItem('expiredtime')) >= curentmni && parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni) {
  //       accessToken = localStorage.getItem('accessToken');
  //       httpOptions = {
  //         headers: new HttpHeaders({
  //           'Content-Type': 'application/json',
  //           'Authorization': 'Bearer ' + accessToken,
  //           'apikey': this.config.apikey,
  //         })
  //       };
  //       return this.http.put(url, data, httpOptions);
  //     } else {
  //       this.refreshToken();
  //     }
  //   }
  // }

  refreshToken() {
    let twentyMinutesLater22 = new Date();
    let curentmni22 = twentyMinutesLater22.setMinutes(twentyMinutesLater22.getMinutes());
    let baseUrl1 = baseUrl
    let enVariable = "";
    if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {
      baseUrl1 = intUrl;
      enVariable = "int";
    } else {
      let aa = baseUrl
      let bb = aa.split(".");
      enVariable = bb[0];
    }
    console.info("current Min", curentmni22);

    if (parseInt(localStorage.getItem('IDPexpiredtime')) >= curentmni22) {

    } else {
      console.info("IDP token expired called", localStorage.getItem('IDPexpiredtime'));




      location.reload();
      console.info("loop called agar");
    }
    if (parseInt(localStorage.getItem('expiredtime')) >= curentmni22) {

    } else {
      console.info("Common token expired called");
      location.reload();
    }
  }

  getEnv() {
    if (this.ENV.envName === "qua" || this.ENV.envName === "re7" || this.ENV.envName === "ope") {
      return false;
    } else {
      return true;
    }
  }

  getEnvSpecific() {
    return this.ENV.envName;
  }

  public getUserInformation() {
    let BaseURL1 = baseUrl
    console.info("App URL", BaseURL1);
    if (BaseURL1 === localUrl) {
      let sims: any = { userinfo: '' };
      /*  US 1983 sims['userinfo'] =
       {
         'company': "RNTBCI PL",
         'costCenter': "QQ13010",
         'email': "aishwarya-priyadharshini.mohan@rntbci.com",
         'firstname': "Srikalyan",
         'lastname': "Mothukuri",
         'mail': "srikalyan.mothukuri@rntbci.com",
         'personType': "catpejv",
         'phone': "+9790732569",
         'postOfficeBox': "INMAAMHA000",
         'preferredLanguage': "en",
         'role-iaf-irn71016': ['admin', 'manager'],
         'sub': "35316538646330322d38346162313165392d38353032396439342d6233373737633866",
         'uid': "z020448",
         'userDirectory': "arca"
       }*/
       const LIFE_TIME = 20000;
       let currentTimestamp = Math.floor(Date.now() / 1000);

      sims['userinfo'] =
      {
        approver: "SELLAPPAN Sivachandran",
        approverId: "z028966",
        approverMail: "sivachandran.chellappan@rntbci.com",
        company: "0774",
        costCenter: "QQ13010",
        countryCode: "IN",
        displayName: "MOHAN Aishwarya-Priyadharshini",
        email: "aishwarya-priyadharshini.mohan@rntbci.com",
        email_verified: true,
        firstName: "Aishwarya-Priyadharshini",
        language: "en_IN",
        lastName: "Mohan",
        login: "z020448",
        mail: "aishwarya-priyadharshini.mohan@rntbci.com",
        mobilePhone: "+91 1111111111",
        perimeter: "None",
        personType: "catpejv",
        personalUniqueId: "00000FTS",
        postOfficeBox: "INMAAMH1000",
        preferredLanguage: "en",
        roles: ['Supplier'] , // ['Admin', 'Manager'],
        sub: "00u10ift2amp4BAhX417",
        title: "Deputy Manager",
        userType: "B2E_Joint-Venture",
        exp: currentTimestamp + LIFE_TIME,

      }

   sims=   {
        "access_token": localStorage.getItem('accessToken'),
        "access_token_expires": "1713159643289",
        "id_token": {
            "sub": "00u10ift2amp4BAhX417",
            "email": "aishwarya-priyadharshini.mohan@rntbci.com",
            "ver": 1,
            "iss": "https://sso-uat.renault.com/oauth2/austwoeshbCkPJyw1416",
            "aud": "irn-71016_uat_code_etzf1u2l2ltg",
            "iat": 1710487805,
            "exp": currentTimestamp + LIFE_TIME,
            "jti": "ID.qQxxI_y0UUPrYTzAqqzxU7HRqLI_yVTy2UKUP-GAbRY",
            "amr": [
                "pwd"
            ],
            "idp": "DSSO",
            "nonce": "TB_hqD8BSIaZqlcMInNisN9QMaNWZPLQsgYuIx4gc3o",
            "auth_time": 1710487804,
            "at_hash": "ijGFJUR9y4iTpoMU78xhtQ",
            "approver": "SELLAPPAN Sivachandran",
            "lastName": "Mohan",
            "personalUniqueId": "00000FTS",
            "preferredLanguage": "en",
            "approverMail": "sivachandran.chellappan@rntbci.com",
            "mail": "aishwarya-priyadharshini.mohan@rntbci.com",
            "displayName": "MOHAN Aishwarya-Priyadharshini",
            "costCenter": "QQ13010",
            "approverId": "z028966",
            "roles": [
                "Admin",
                "Manager"
            ],
            "language": "en_IN",
            "login": "z020448",
            "title": "Deputy Manager",
            "firstName": "Aishwarya-Priyadharshini",
            "postOfficeBox": "INMAAMH1000",
            "mobilePhone": "+91 8939166441",
            "countryCode": "IN",
            "perimeter": "None",
            "company": "0774",
            "userType": "B2E_Joint-Venture",
            "personType": "catpejv"
        },
        "userinfo": {
            "sub": "00u10ift2amp4BAhX417",
            "email": "aishwarya-priyadharshini.mohan@rntbci.com",
            "email_verified": true,
            "approver": "SELLAPPAN Sivachandran",
            "lastName": "Mohan",
            "personalUniqueId": "00000FTS",
            "preferredLanguage": "en",
            "approverMail": "sivachandran.chellappan@rntbci.com",
            "mail": "aishwarya-priyadharshini.mohan@rntbci.com",
            "displayName": "MOHAN Aishwarya-Priyadharshini",
            "costCenter": "QQ13010",
            "approverId": "z028966",
                       "roles": [
                "Admin",
                "Manager"
            ],
            "language": "en_IN",
            "login": "z020448",
            "title": "Deputy Manager",
            "firstName": "Aishwarya-Priyadharshini",
            "postOfficeBox": "INMAAMH1000",
            "mobilePhone": "+91 8939166441",
            "countryCode": "IN",
            "perimeter": "None",
            "company": "0774",
            "userType": "B2E_Joint-Venture",
            "personType": "catpejv"
        }
      }
      return new Observable(news => {
        console.info('sim',sims)
        news.next(sims);
      });

    }
    return this.http.get(`${BaseURL1}/auth/profile.json`);
  }

  public async  getUserInformationOkta() {
    let BaseURL1 = baseUrl
    console.info("App URL", BaseURL1);

      let twentyMinutesLater = new Date();
      let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());

 if (localStorage.getItem('loginit')!='true' || ( localStorage.getItem('IDPexpiredtime') === null || localStorage.getItem('IDPexpiredtime') === "null" || parseInt(localStorage.getItem('IDPexpiredtime')) <= curentmni) ){
  let i = window.location.href.indexOf("code")
  if(i==-1){
  
  if(localStorage.getItem('loginit')!='loggedOut'){
    localStorage.setItem('loginit','true')
    this.authorizationService.loginInit()
  }else{
    let user= await this.authorizationService.getUser()  ;
    if(user==null){
      this.authorizationService.loginInit()

    }else{
return user;
    }
    }
  }else{
    let user= await this.authorizationService.getUser()  ;
    if(user==null){
      this.authorizationService.loginInit()

    }else{
return user;
    }
    }

}else{
let user= await this.authorizationService.getUser()  ;
if(user==null){
  this.authorizationService.loginInit()

}else{
return user;
}
console.info("user",user)
 }

    
  }
getchecktest(){
  return 'check ok for new version-83'
}
getData(): Observable<any> {
  let jsonUrl = 'assets/settings.json';
   return this.http.get<any>(jsonUrl);
 }
 setRole(role: string): void {
  this.fromApp_UserRole = role;
  localStorage.setItem('userRole', role); 
  localStorage.setItem("rolechange",'false')
  console.info(`Role set to: ${role}`);
}
  splitAndRolesAssign() {


    let arrayDataInfo: any = [];
    let role: any = this.fromApp_UserRole;
    if (typeof role != 'string') {

      if (Array.isArray(role)) {
        role = role.map(ele => {
          return ele.toLowerCase()
        }
        )
      }
    } else {
      role = [role.toLowerCase()] ;
    }
    let vals: any = [];
    if (this.fromApp_UserRole) {
      vals['userAccess'] = "Yes";
      vals['userIpn'] = this.fromApp_UserIPN;
      vals['userEmail'] = this.fromApp_UserEmail;
      vals['userName'] = this.fromApp_UserName;
      let env = this.ENV.envName;

      if (role === 'buyer' || role.includes('buyer')) {
        vals['buyer'] = 'yes';
      } else {
        vals['buyer'] = 'no';
      }


      if (role === 'manager' || role.includes('manager')) {
        vals['manager'] = 'yes';
      } else {
        vals['manager'] = 'no';
      }


      if (role === 'admin' || role.includes('admin')) {
        vals['admin'] = 'yes';
      } else {
        vals['admin'] = 'no';
      }


      vals['role'] = role;


      vals['env'] = env;


      if (role.includes('manager') && role.includes('admin')) {
        vals['superAdmin'] = 'yes';
      } else {
        vals['superAdmin'] = 'no';
      }


      if (env === 'int') {
        vals['superAdminAllProfiles'] = 'yes';
      } else {
        if ((env === 'ope' || env === 're7' || env === 'qua') && role.includes('manager') && role.includes('admin')) {
          vals['superAdminAllProfiles'] = 'yes';
        } else {
          vals['superAdminAllProfiles'] = 'no';
        }
      }
      return vals;
    } else {
      vals['userAccess'] = "Deined";
      return vals;
    }
  }

  getUserId() {
    if (this.fromApp_UserIPN) {
      return this.fromApp_UserIPN;
    } else {
      return null;
    }
  }
  matomoCall(path, title) {
    if (path != undefined) {
      // Tracker is already configured via MATOMO_CONFIGURATION in app.module
      this.matomoTracker.setUserId(this.getUserId());
      this.matomoTracker.trackEvent(`ISA-${path}`, title, this.fromApp_UserIPN);
    }
  }
  getRoleAndProfileInfo() {
    let arrayDataInfo: any = [];
    this.getUserInformation().subscribe(values => {
      let role: any = values['userinfo']['role-iaf-irn71016'];
      let env = this.ENV.envName;
      let vals: any = [];

      if (role === 'buyer' || role.includes('buyer')) {
        vals['buyer'] = 'yes';
      } else {
        vals['buyer'] = 'no';
      }


      if (role === 'manager' || role.includes('manager')) {
        vals['manager'] = 'yes';
      } else {
        vals['manager'] = 'no';
      }


      if (role === 'admin' || role.includes('admin')) {
        vals['admin'] = 'yes';
      } else {
        vals['admin'] = 'no';
      }


      vals['role'] = role;


      vals['env'] = env;


      if (env === 'ope' && role.includes('manager') && role.includes('admin')) {
        vals['superAdmin'] = 'yes';
      } else {
        vals['superAdmin'] = 'no';
      }


      if (env === 'int') {
        vals['superAdminAllProfiles'] = 'yes';
      } else {
        if ((env === 'ope' || env === 're7' || env === 'qua') && role.includes('manager') && role.includes('admin')) {
          vals['superAdminAllProfiles'] = 'yes';
        } else {
          vals['superAdminAllProfiles'] = 'no';
        }
      }
      arrayDataInfo = vals;
    });
    return arrayDataInfo;
  }


  getSpToken() {
    let twentyMinutesLater = new Date();
    let curentmni = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes());
    if (localStorage.getItem('SP_accessToken') && parseInt(localStorage.getItem('SP_expiredtime')) <= curentmni) {
      let baseUrl1 = baseUrl
      if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {

      } else {

        this.http.get(`${baseUrl1}/api/sp_access_token`).subscribe((Acc_token: any) => {
          let frmTime = Math.round((Acc_token.expires_in) / 60);
          let thirtymin = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + frmTime);
          localStorage.setItem('SP_accessToken', Acc_token.access_token);
          localStorage.setItem("SP_expiredtime", JSON.stringify(thirtymin));
        });
      }
    } else if (!localStorage.getItem('SP_accessToken')) {
      let baseUrl1 = baseUrl

      this.http.get(`${baseUrl1}/api/sp_access_token`).subscribe((Acc_token: any) => {
        console.info("token ---3", Acc_token);
        let frmTime = Math.round((Acc_token.expires_in) / 60);
        let thirtymin = twentyMinutesLater.setMinutes(twentyMinutesLater.getMinutes() + frmTime);
        localStorage.setItem('SP_accessToken', Acc_token.access_token);
        localStorage.setItem("SP_expiredtime", JSON.stringify(thirtymin));
      });
    }
  }


  getTodayDate() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();
    let todayDate = `${yyyy}-${mm}-${dd}`;
    return todayDate;
  }

  getTwoDaysAoDate(): string {
    const date = new Date();
    date.setDate(date.getDate() - 2); // Subtract 2 days from the current date
    const day = (`0${date.getDate()}`).slice(-2); // Get the day and pad with leading zero if needed
    const month = (`0${(date.getMonth() + 1)}`).slice(-2); // Get the month and pad with leading zero if needed
    const year = date.getFullYear(); // Get the year
    return `${year}-${month}-${day}`; // Return the date in YYYY-MM-DD format
  }


  getOneWeekAgoDate() {
    let today = new Date();
    let oneWeekAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
    let dd = String(oneWeekAgo.getDate()).padStart(2, '0');
    let mm = String(oneWeekAgo.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = oneWeekAgo.getFullYear();
    let todayDate = `${yyyy}-${mm}-${dd}`;
    return todayDate;
  }


  getTwoWeekAgoDate() {
    let today = new Date();
    let oneWeekAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 14);
    let dd = String(oneWeekAgo.getDate()).padStart(2, '0');
    let mm = String(oneWeekAgo.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = oneWeekAgo.getFullYear();
    let todayDate = `${yyyy}-${mm}-${dd}`;
    return todayDate;
  }


  getOneMonthAgoDate() {
    let today = new Date();
    let oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    let dd = String(oneMonthAgo.getDate()).padStart(2, '0');
    let mm = String(oneMonthAgo.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = oneMonthAgo.getFullYear();
    let todayDate = `${yyyy}-${mm}-${dd}`;
    return todayDate;
  }


  getThreeMonthAgoDate() {
    let today = new Date();
    let threeMonthAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
    let dd = String(threeMonthAgo.getDate()).padStart(2, '0');
    let mm = String(threeMonthAgo.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = threeMonthAgo.getFullYear();
    let todayDate = `${yyyy}-${mm}-${dd}`;
    return todayDate;
  }

  getCustomURLOrbis(url) {
    let baseUrl1 = baseUrl
    if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {
      baseUrl1 = intUrl;

    }
    let datas = {
      "qry": url,
    }
    let token = localStorage.getItem("IDPAccessToken");

    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    };
    return this.http.post(`${baseUrl1}/api/getInPortfolio`, datas, httpOptions);
  }

private baseUrl = 'https://api.bvdinfo.com/v1/orbis/Companies/data';



  callBVDGet(bvdId: string): Observable<any> {
    const queryObj = {
      Globals: {
        GUODefinition: {
          MinimumPercentage: 50.01,
          UnidentifiedShareholders: true,
          HighestQuoted: false,
          Types: {
            Bank: false,
            FinancialCompany: false,
            InsuranceCompany: false,
            Corporate: true,
            PrivateEquityFirm: false,
            HedgeFund: false,
            VentureCapital: false,
            MutualPensionFundOrTrust: false,
            Foundation: false,
            PublicAuthority: false,
            Individual: false,
            ManagerOrDirector: false
          }
        }
      },
      WHERE: [{ BvDID: [bvdId] }],
      SELECT: [
        "NAME", "LEGAL_ACCOUNT_INFORMATION.STATUS", "LEGAL_ACCOUNT_INFORMATION.STATUS_DATE",
        "BVD_ID_NUMBER", "STANDARDISED_LEGAL_FORM", "HQ_BVD_ID_NUMBER", "ADDRESS_LINE1",
        "ADDRESS_LINE2", "ADDRESS_LINE3", "POSTCODE", "CITY", "COUNTRY_REGION",
        "COUNTRY_ISO_CODE", "COUNTRY", "LATITUDE", "LONGITUDE", "VAT_NUMBER",
        "EUROPEAN_VAT_NUMBER", "NATIONAL_ID_LABEL", "NATIONAL_ID", "BRANCH_INDICATOR",
        "BRANCH_NAME", "BRANCH_BVD_ID_NUMBER", "BRANCH_NATIONAL_ID", "BRANCH_AKA_NAME",
        "BRANCH_ADDRESS_LINE1", "BRANCH_ADDRESS_LINE2", "BRANCH_ADDRESS_LINE3",
        "BRANCH_ADDRESS_LINE4", "BRANCH_POSTCODE", "BRANCH_CITY",
        "BRANCH_COUNTRY_ISO_CODE", "GUO_NAME", "GUO_BVD_ID_NUMBER",
        "GUO_DIRECT_PCT", "GUO_TOTAL_PCT"
      ]
    };


    const queryString = encodeURIComponent(JSON.stringify(queryObj));


    const finalUrl = `${this.baseUrl}?QUERY=${queryString}`;


    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'apitoken': '31YE968e852fc9d846b8950fd60e364f29fb'
    });


    return this.http.get(finalUrl, { headers });
  }

  putCustomURLOrbis(url, data: any) {
    let baseUrl1 = baseUrl
    if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {
      baseUrl1 = intUrl

    }
    let datas = {
      "qry": url,
      "param": data
    }
    let token = localStorage.getItem("IDPAccessToken");

    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    };
    return this.http.post(`${baseUrl1}/api/putInPortfolio`,  datas, httpOptions);
  }
getParamCheckParams(){
  console.info("check")
  console.info("check2")
  let datas = {
    "qry": 'url',
    "param": 'data'
  }
  console.info(datas)

}
  getHappi() {
    let baseUrl1 = baseUrl
    if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {
      baseUrl1 = intUrl;
  
    }
    let token = (localStorage.getItem("IDPAccessToken") !=null || ((localStorage.getItem("IDPAccessToken") !=undefined && localStorage.getItem("IDPAccessToken") !=null)) ? localStorage.getItem("IDPAccessToken") : localStorage.getItem("accessToken"));
    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    };
  return this.http.get(`${baseUrl1}/api/getHappiCred`, httpOptions).pipe(
    map((res: any) => {

      const decryptedData = this.configservice.decrypt(res);


      if (this.config.apikey === "") {
        this.configservice.setApiConfig(decryptedData);
      }

  
      return decryptedData;
    })
  );
  }
  getDocument() {
    let baseUrl1 = baseUrl
    if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {
      baseUrl1 = intUrl;
    }
    return `${baseUrl1}/api/`
  }

  copyToClipboard(text: string): void {
    navigator.clipboard.writeText(text)
      .then(() => {
       
      })
      .catch((error) => {
        console.error('Failed to copy to clipboard:', error);
      });
  }

  getGitVarConfig() {
    let baseUrl1 = baseUrl
    if (baseUrl1 === localUrl || baseUrl1 === `${localUrl}/`) {
      baseUrl1 = intUrl

    }
    let token = localStorage.getItem("IDPAccessToken") !=null || localStorage.getItem("IDPAccessToken") !=undefined? localStorage.getItem("IDPAccessToken") : localStorage.getItem("accessToken");

    let httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    };
    this.http.get(`${baseUrl1}/api/getConfigVariables`,httpOptions).subscribe(val => {
      this.PortfolioRecordSet = val['BVD_PORTFOLIO_RECORDSET'];

    })






  }
  getenv() {
    return this.http.get('/assets/env.json');
  }


  isAllActiveTaskReady(): boolean {
    return this.allActiveTask && this.allActiveTask.length > 0;
  }


  clearAllActiveTask(): void {
    this.allActiveTask = [];
  }


  setAllActiveTask(data: any[]): void {
    this.allActiveTask = [...data];
  }

  hasNoSpecialCharacters(cityS ,city ): string {


    if(cityS!=null){

  const allowedCharactersPattern = /^[A-Za-z -]*$/;
     if(allowedCharactersPattern.test(cityS)){
      return cityS
     }
      else{
        if(city!=null){
          return city
        }
     }
    }
    else if(city!=null){
      return city
    } else{
    return "UNKNOWN";
    }
  }

    cityCreationOptimization(cityS: string, city: string, countryIsoCode = '', countryId = ''): Observable<any> {
    const citiesApiUrl = `${this.config.ApiCountryUrl}cities`;
    const getProxyUrl = `${this.config.CountryServiceUrl}/get-cities`;
    const createProxyUrl = `${this.config.CountryServiceUrl}/create-cities`;
      const escapeFilterValue = (value: string): string => value.replace(/\u2019/g, "'").replace(/'/g, "''");
      const escapedCityS = cityS ? escapeFilterValue(cityS) : cityS;
      const escapedCity = city ? escapeFilterValue(city) : city;

    const searchCities = (params: string): Observable<any> =>
      this.getServiceCall(getProxyUrl, `${citiesApiUrl}?${params}`).pipe(
        catchError(error => throwError(() => error))
      );

    const createCity = (name: string): Observable<any> =>
      this.postServiceCall(createProxyUrl, citiesApiUrl, {
        countryCode: countryIsoCode,
        name,
        active: '1',
        countryId:countryId,
      });

    const resolveUnknown = (): Observable<any> => {
      const cc = countryIsoCode || 'CC';
      return this.getServiceCall(getProxyUrl, `${citiesApiUrl}?countryCode=${cc}&name=UNKNOWN`).pipe(
        switchMap((data: any) => {
          const cities: any[] = data?.cities ?? [];
          if (cities.length >= 1) {
            return of(cities[0]);
          }
          return this.postServiceCall(createProxyUrl, citiesApiUrl, {
            countryCode: cc,
            name: 'UNKNOWN',
            active: '1'
          });
        })
      );
    };

    // Preliminary checks: missing country or both city fields empty
    if (!countryIsoCode || (!cityS && !city)) {
      return resolveUnknown();
    }

    // Request #3: synonyme search on CITY, create if no match
    const request3 = (): Observable<any> =>
      searchCities(`countryCode=${countryIsoCode}&synonyme=*//${escapedCity || escapedCityS}//*`).pipe(
        switchMap((data: any) => {
          const cities: any[] = data?.cities ?? [];
          if (cities.length >= 1) {
            return of(cities[0]);
          }
          return createCity(cityS || city);
        })
      );

    // Request #2: synonyme search on CITY_STANDARDIZED, fall through to #3
    const request2 = (): Observable<any> =>
      searchCities(`countryCode=${countryIsoCode}&synonyme=*//${escapedCityS}//*`).pipe(
        switchMap((data: any) => {
          const cities: any[] = data?.cities ?? [];
          return cities.length >= 1 ? of(cities[0]) : request3();
        })
      );

    // Request #1a: CITY_STANDARDIZED differs from CITY — search both
    if (cityS && cityS !== city) {
      return searchCities(
        `countryCode=${countryIsoCode}&name=in('${escapedCityS}','${escapedCity}')`
      ).pipe(
        switchMap((data: any) => {
          const cities: any[] = data?.cities ?? [];
          if (cities.length === 1) {
            return of(cities[0]);
          }
          if (cities.length > 1) {
            const preferred = cities.find((c: any) => c.name === cityS);
            return of(preferred ?? cities[0]);
          }
          return request2();
        })
      );
    }

    // Request #1b: CITY_STANDARDIZED empty or same as CITY — search by name
    const searchName = escapedCityS || escapedCity;
    return searchCities(`countryCode=${countryIsoCode}&name=${searchName}`).pipe(
      switchMap((data: any) => {
        const cities: any[] = data?.cities ?? [];
        if (cities.length >= 1) {
          return of(cities[0]);
        }
        return request3();
      })
    );
  }
  infobtndsp(folio): boolean {

    if (!this.isAllActiveTaskReady()) {

      return false;
    }
    
    let changed = folio.match(/^(.*_)(\d.*)$/);
    if (!changed || !changed[1]) {
      console.warn('Invalid folio format:', folio);
      return false;
    }
    
    const current_WrkFlow = this.allActiveTask.filter(x => x.folio && x.folio.includes(changed[1]))[0];
    if(current_WrkFlow !=undefined && current_WrkFlow !=null){
      if(current_WrkFlow['activityName'] === 'Task' || current_WrkFlow['activityName'] === 'Task 3'){
        return false
      }
      else{
        return true
      }
    }
    
    return false;
  }

}